import React, { useEffect, useState } from 'react';
import ListItem from '@material-ui/core/ListItem';
import { updateMenuSection, updateMenuItem } from '@api';
import ListItemText from '@material-ui/core/ListItemText';
import { useStyles } from './styles';
import { Switch, withStyles, Grid, ListItemIcon } from '@material-ui/core';
import { Fastfood } from '@material-ui/icons';
import { useMenuContext } from '../../hooks';
export const CustomSwitch = withStyles({
  switchBase: {
    '&$checked': {
      color: '#FF8D07',
    },
    '&$checked + $track': {
      backgroundColor: '#FF8D07',
    },
  },
  checked: {},
  track: {},
})(Switch);
const ManageMenuItem = ({ item, selected, setSelected, itemList }) => {
  const classes = useStyles();
  const [checked, updateChecked] = useState(item.enabled);
  const { fetchMenuSectionsListForService } = useMenuContext();

  useEffect(() => {
    updateChecked(item.enabled);
    // eslint-disable-next-line
  }, []);

  const changeItemState = async () => {
    item.icon
      ? await updateMenuItem(item.id, item.enabled)
      : await updateMenuSection(item.id, item.enabled);
    await fetchMenuSectionsListForService();
    updateChecked(!checked);
  };

  return (
    <ListItem
      button
      onClick={itemList ? undefined : () => setSelected(item.id)}
      className={classes.nested}
    >
      <Grid
        container
        className={`${classes.grid} ${
          selected === item.id ? classes.selected : ''
        }`}
      >
        {itemList && (
          <ListItemIcon>
            <Fastfood />
          </ListItemIcon>
        )}
        <ListItemText primary={item.name} />
        <CustomSwitch checked={checked} onChange={changeItemState} />
      </Grid>
    </ListItem>
  );
};

export default ManageMenuItem;
